export default __webpack_public_path__ + "static/media/Gloves.5be5df0f.png";